<template>
    <div>
        <Chart :cdata="cdata" />
    </div>
</template>

<script>
import Chart from './chart.vue';
import { transferInvoice, transportTotal } from '../../api/holdMy';
import { getToken } from '../../utils/getToken';
export default {
    data() {
        return {
            cdata: {
                category: [
                    "网络货运",
                    "加油金额",
                    "运费"
                ],
                rateData: []
            },
            transferInvoiceQty: [],
            drawTiming: null,
            oilAmount: 0,
            totalQty: 0,
        };
    },
    components: {
        Chart,
    },
    mounted() {
        this.drawTimingFn();
        // this.setData();

    },
    beforeDestroy() {
        clearInterval(this.drawTiming);
    },
    methods: {
        drawTimingFn() {
            this.getTransferInvoice();
            this.drawTiming = setInterval(() => {
                this.getTransferInvoice();
            }, 6000*5);
        },
        async init() {
            await this.getTransferInvoice();
            await this.getTransportTotal();
            await this.setData();
        },
        // 根据自己的业务情况修改
        async setData() {
            // 清空轮询数据
            this.cdata.rateData = [];
            var dateDiff = Math.round((new Date().getTime() - new Date('2021-11-04 00:00:00').getTime()) / (1000 * 60), 0);//时间差的分钟数
            var data = [(this.transferInvoiceQty.length >= 1 ? (10000 + parseFloat((this.transferInvoiceQty[0].payActualMoney / 10000).toFixed(4))) : 0),
            (parseFloat((this.oilAmount / 10000).toFixed(2))) ? (parseFloat((this.oilAmount / 10000).toFixed(2))) : (87628 + dateDiff * 1.52).toFixed(2), this.totalQty * 300 / 10000]
            this.cdata.rateData = data;
        },

        async getTransferInvoice() {
            let data = {
                autoIncId: 1,// id
                token: getToken("holdpjToken")
            }
            transferInvoice(data).then(res => {
                if (res.result == 0) {
                    this.transferInvoiceQty = res.userdata;
                    this.getTransportTotal();
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 运输
        async getTransportTotal() {
            let data = {
                type: "2",// 传入用户id
                token: getToken("holdpjToken")
            }
            transportTotal(data).then(res => {
                if (res.result == 0) {
                    this.totalQty = res.userdata + 10000000;
                    this.setData();
                }
            }).catch(error => {
                console.log(error);
            })
        }
    }
};
</script>

<style lang="scss" scoped></style>